import { createContext, Dispatch, SetStateAction } from "react";

export const JourneyExcellenceContext = createContext<{
  metric: string;
  setMetric: Dispatch<SetStateAction<string>>;
  //@ts-ignore
}>({ metric: "" });
